import {
  AlignmentType,
  Document,
  ImageRun,
  Paragraph,
  VerticalAlign,
  PageNumber,
  TextRun,
} from "docx";

import * as docx from "docx";

import {
  breakLine,
  DocXTableColumn,
  table,
  text,
} from "../../../company-office/request-vehicle/TemplateDocx/Template/common";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";

export const recallToolDocx = (item: any) => {
  const imageData = logoBase64;

  const jsonString = item.fields.eContent;
  const dataArray = JSON.parse(jsonString);

  const columnsList: DocXTableColumn<{
    toolName: string;
    toolId: string;
    Dram: string;
    Quantity: string;
    reason: string;
  }>[] = [
    {
      label: "STT",
      renderText: (item, index) => text((index + 1).toString()),
    },
    {
      label: "Tên CCDC",
      renderText: (item) => text(item.toolName.toString()),
    },
    {
      label: "Mã CCDC",
      renderText: (item) => text(item.toolId.toString()),
    },
    {
      label: "ĐVT",
      renderText: (item) => text(item.Dram.toString()),
    },
    {
      label: "Số lượng",
      renderText: (item) => text(item.Quantity.toString()),
    },
    {
      label: "Lí do",
      renderText: (item) => text(item.reason?.toString() || ""),
    },
  ];

  return new Document({
    sections: [
      {
        headers: {
          default: new docx.Header({
            children: [
              new docx.Table({
                rows: [
                  new docx.TableRow({
                    children: [
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new ImageRun({
                                data: imageData,
                                transformation: {
                                  width: 150,
                                  height: 50,
                                },
                              }),
                            ],
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        verticalAlign: VerticalAlign.CENTER,
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "Biểu mẫu",
                                bold: true,
                                size: 24,
                                color: "000000",
                                italics: true,
                              }),
                            ],
                            alignment: AlignmentType.LEFT,
                          }),

                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "PHIẾU ĐỀ NGHỊ THU HỒI CCDC",
                                bold: true,
                                size: 24,
                                color: "000000",
                              }),
                            ],
                            spacing: {
                              before: 200,
                              after: 200,
                            },
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                // text: `Mã số: ${item.fields.eIssueNumber}`,
                                text: "Mã số: V.SPM-F45",
                                size: 24,
                              }),
                              new docx.TextRun({
                                // text: `Lần ban hành: ${item.fields.eIssueTimes}`,
                                text: "Lần ban hành: 01",
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                // text: `Ngày hiệu lực: ${getDDMMYYYFormat(
                                //   item.fields.eIssueEffectiveDate
                                // )}`,
                                text: "Ngày hiệu lực: 19/5/2023",
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                text: "Trang: ",
                                size: 24,
                                break: 1,
                              }),
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    children: [
                                      PageNumber.CURRENT,
                                      "/",
                                      PageNumber.TOTAL_PAGES,
                                    ],
                                    size: 24,
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: {
                          top: 0,
                          bottom: 100,
                          left: 100,
                          right: 100,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        },

        children: [
          breakLine(1),
          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: `PHIẾU ĐỀ NGHỊ THU HỒI CCDC`,
                size: 28,
                bold:true
              })
            ],
            alignment: AlignmentType.CENTER,
          }),

          breakLine(1),
          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: "1.  ",
                size: 24,
                bold: true,
              }),
              new docx.TextRun({
                text: "Nội dung đề nghị",
                size: 24,
                bold: true,
                underline: {
                  type: docx.UnderlineType.SINGLE,
                },
              }),
            ],
          }),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: `Đơn vị đề nghị: ${item.fields.eDepartment}`,
                size: 24,
              }),
              new docx.TextRun({
                break: 2,
                text: `Danh mục CCDC đề nghị thu hồi:`,
                size: 24,
              }),
            ],
          }),

          breakLine(1),

          table({
            columns: columnsList,
            data: dataArray,
          }),

          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: "2.  ",
                size: 24,
                bold: true,
              }),
              new docx.TextRun({
                text: "Đánh giá tình trạng kỹ thuật:",
                size: 24,
                bold: true,
                underline: {
                  type: docx.UnderlineType.SINGLE,
                },
              }),
            ],
          }),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: `Đơn vị kiểm tra tình trạng kỹ thuật: ${
                  item.fields?.eInspectionUnit || ""
                }`,
                size: 24,
              }),
              new docx.TextRun({
                break: 1,
                text: `Đánh giá: ${item.fields?.eInspectionUnitComment || ""}`,
                size: 24,
              }),
            ],
          }),

          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: `THỦ TRƯỞNG ĐƠN VỊ SỬ DỤNG`,
                bold: true,
                size: 24,
              }),

              new docx.TextRun({
                text: `     NGƯỜI LẬP     `,
                bold: true,
                size: 24,
              }),

              new docx.TextRun({
                text: `BỘ PHẬN KỸ THUẬT`,
                bold: true,
                size: 24,
              }),
            ],
          }),

          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),
          breakLine(1),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: "3.  ",
                size: 24,
                bold: true,
              }),
              new docx.TextRun({
                text: "Ý kiến của Phòng KHĐT:",
                size: 24,
                bold: true,
                underline: {
                  type: docx.UnderlineType.SINGLE,
                },
              }),
              new docx.TextRun({
                break: 1,
                text: "     ",
                size: 24,
                bold: true,
              }),
              new docx.SymbolRun({
                char: "F071",
                size: 40,
              }),
              new docx.TextRun({
                text: "     Đồng ý",
                size: 24,
                bold: true,
              }),
              new docx.TextRun({
                break: 1,
                text: "     ",
                size: 24,
                bold: true,
              }),
              new docx.SymbolRun({
                char: "F071",
                size: 40,
              }),
              new docx.TextRun({
                text: "     Không đồng ý",
                size: 24,
                bold: true,
              }),
            ],
          }),

          new docx.Paragraph({
            children: [
              new docx.TextRun({
                text: "PHÒNG KẾ HOẠCH ĐẦU TƯ",
                size: 24,
                bold: true,
              }),
            ],
            alignment: AlignmentType.RIGHT,
          }),
        ],
      },
    ],
  });
};
